/* Cookie notice (assets/almila-cookie-notice.css): while the bar shows, <html> carries
   .almila-cookie-notice-open and the bar's height in --almila-cookie-notice-height, so the end of the page and the
   back-to-top button stay clear of it. Presentation only: the choice itself is in
   snippets/almila-cookie-reject.liquid and the theme's app.js. The keyboard reaches the notice right after the
   skip link because it follows the link in the page (layout/theme.liquid) and Tab follows the page
   (assets/almila-a11y.js). */
(function () {
  'use strict';
  var bar = document.getElementById('cookiebarBox');
  if (!bar) return;
  var root = document.documentElement;
  function shown() {
    var style = window.getComputedStyle(bar);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }
  function sync() {
    var open = shown();
    root.classList.toggle('almila-cookie-notice-open', open);
    if (open) root.style.setProperty('--almila-cookie-notice-height', bar.offsetHeight + 'px');
    else root.style.removeProperty('--almila-cookie-notice-height');
  }
  if (window.MutationObserver) new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
  if (window.ResizeObserver) new ResizeObserver(sync).observe(bar);
  window.addEventListener('load', sync);
  sync();
})();
